import { AUTH_URL } from "../constants";
import { AUTH_KEY } from "../context/authContext";
import { APIRequest, HTTPClient, RequestType } from "../services/http_client"
import LocalStorageService from "../services/localstorage.service";
import { StaticAdType } from "../types/staticAd";

const client = new HTTPClient();

export interface ResponseType {
    staticAd?: {
        data : Array<StaticAdType>;
    };
    error?: string;
}

export interface StaticAdFormResponse {
    success: boolean;
    error?: string;
}


class StaticAdModel {
    static async save(item: StaticAdType){
        const auth = LocalStorageService.get(AUTH_KEY)
        if(!auth) return {
            error: "Unauthorized"
        }

        const request = new APIRequest(
            RequestType.PUT,
            `${AUTH_URL}/static-ads/${item.id}`,
            JSON.stringify(item),
            auth.accessToken,
        );

        const response = await client.put(request);

        if (!response.success) {
            return {
                error: response.errorMessage,
            }
        }
  
        return response.result as unknown as StaticAdFormResponse
    }

    static async find(itemId: number){
        const auth = LocalStorageService.get(AUTH_KEY)
        if(!auth) return {
            error: "Unauthorized"
        }

        const request = new APIRequest(
            RequestType.GET,
            `${AUTH_URL}/static-ads/${itemId}`,
            undefined,
            auth.accessToken,
        );

        const response = await client.get(request);

        if (!response.success) {
            return {
                error: response.errorMessage
            }
        }
  
        return response.result as unknown as ResponseType
    }
}

export default StaticAdModel